import React, { useEffect, useState } from "react";
import {
  SpocModel,
  WarehouseModel,
} from "../../../../../erp/inventory/models/warehouse_model";
import WarehouseMultiSelect from "../../../../../erp/inventory/warehouse/warehouse_multi_select";
import { TeamManagementOfWarehosues } from "../../../../../erp/inventory/models/inventory_warehouse_spoc_model";
import {
  ToastType,
  useToast,
} from "../../../../../context_providers/toast/toast_ctx";
import EmployeeSearchWidget from "../../../../new_components/emp_search_widget";
import {
  CreateMultiWarehouseForSameMemberAPI,
  UpdateSpocWarehousesAPI,
} from "../../warehouses/components/warehouse_spoc_mangement_apis";
import LoadingWidget from "../../../../../context_providers/modal/loader";

interface Props {
  editData?: TeamManagementOfWarehosues;
  onClose: () => void;
  onSaved?: () => void;
}

export const AddMembersToWarehouse: React.FC<Props> = ({
  onClose,
  editData,
  onSaved,
}) => {
  const [data, setData] = useState<TeamManagementOfWarehosues>({
    member: {} as SpocModel,
    role: "",
    warehouses: [],
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  console.log("editData:", editData);
  const { showToast } = useToast();
  const disabled = !!editData;
  useEffect(() => {
    setData((prev) => ({
      ...prev,
      role: "warehouse operator",
    }));
  }, []);

  useEffect(() => {
    if (!editData) return;

    const normalizedWarehouses: WarehouseModel[] = (editData.warehouses || [])
      .map((w: any) => w.warehouse)
      .filter(Boolean);

    setData({
      member: editData.member,
      role: editData.role,
      warehouses: normalizedWarehouses,
    });
  }, [editData]);

  // console.log("data111:", editData)

  const onSubmit = async (data: TeamManagementOfWarehosues) => {
    try {
      if (!data.member?.uid) {
        showToast({
          type: ToastType.error,
          text: "Select a member first",
        });
        return;
      }

      if (!data.warehouses?.length) {
        showToast({
          type: ToastType.error,
          text: "Select at least one warehouse",
        });
        return;
      }

      setIsSubmitting(true);
      const payload = {
        ...data,
      };
      let response;
      if (disabled) {
        response = await UpdateSpocWarehousesAPI(payload);
      } else {
        response = await CreateMultiWarehouseForSameMemberAPI(payload);
      }
      console.log("response:", response);
      if (!response.success) {
        showToast({
          type: ToastType.error,
          text: response.error,
        });
      } else {
        showToast({
          type: ToastType.success,
          text: "Warehouse SPOCs saved successfully",
        });
        onSaved?.();
        onClose();
      }
    } catch (error: any) {
      console.error("API Error full object:", error);

      showToast({
        type: ToastType.error,
        text: error.message || "Something went wrong",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      id="warehouse-team-assign-warehouse-modal"
      className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center p-4"
    >
      <div className="bg-white w-full max-w-[500px] rounded-lg p-4 space-y-4 wh-modal-xs max-h-[90vh] overflow-y-auto">
        <h2 className="text-lg font-semibold">Assign Warehouses to Member</h2>

        {/* SPOC Multi Select */}
        <h2 className="font-semibold flex">Select Member</h2>
        <EmployeeSearchWidget
          disabled={disabled}
          withBtn={false}
          onSelect={(emp) => {
            setData((pv) => {
              return {
                ...pv!,
                member: {
                  uid: emp.uid,
                  contact_name: emp.first_name + " " + emp.last_name,
                  contact_mobile: emp.mobile,
                  contact_email: emp.email,
                  department: emp.emp_profile?.department,
                },
                // reporting_to_id: emp.uid,
                // reporting_to_name: emp.first_name + " " + emp.last_name,
              };
            });
          }}
          emp={
            data?.member?.uid
              ? {
                  uid: data?.member?.uid!,
                  name: data?.member?.contact_name!,
                }
              : undefined
          }
        />

        {/* Role Select */}
        <h2 className="font-semibold flex">SPOC Role</h2>
        <select
          id="warehouse-team-role-select"
          className="w-full border p-2 rounded"
          disabled={disabled}
          value={data.role}
          onChange={(e) =>
            setData((prev) => ({
              ...prev,
              role: e.target.value,
            }))
          }
        >
          {/* <option value="">Select Role</option> */}
          <option value="warehouse operator">warehouse operator</option>
        </select>

        <h2 className="font-semibold">Select Warehouses</h2>

        <WarehouseMultiSelect
          type="internal"
          selectedWarehouses={data.warehouses}
          onSelect={(warehouse: WarehouseModel) => {
            setData((prev) => {
              if (prev.warehouses.some((w) => w.id === warehouse.id)) {
                return prev; // prevent duplicates
              }

              return {
                ...prev,
                warehouses: [...prev.warehouses, warehouse],
              };
            });
          }}
          onDelete={(id: string) => {
            setData((prev) => ({
              ...prev,
              warehouses: prev.warehouses.filter((w) => w.id !== id),
            }));
          }}
        />
        {/* Actions */}
        <div className="flex justify-end gap-2">
          <button
            id="warehouse-team-assign-cancel-btn"
            onClick={onClose}
            className="px-4 py-2 border rounded"
          >
            Cancel
          </button>

          <button
            id="warehouse-team-assign-submit-btn"
            onClick={() => onSubmit(data)}
            disabled={
              isSubmitting || !data.member?.uid || data.warehouses.length === 0
            }
            className={`px-4 py-2 bg-blue-600 text-white rounded transition-all min-w-[80px] flex items-center justify-center ${
              isSubmitting || !data.member?.uid || data.warehouses.length === 0
                ? "opacity-50 cursor-not-allowed"
                : "hover:bg-blue-700"
            }`}
          >
            {isSubmitting
              ? disabled
                ? "Updating..."
                : "Assigning..."
              : disabled
                ? "Update"
                : "Assign"}
          </button>
        </div>
      </div>
      {isSubmitting && <LoadingWidget />}
    </div>
  );
};
